module.exports = __webpack_public_path__ + "static/media/icon_location_store.ffd612a7.png";